import { waitFor } from '@goodboydigital/astro';
import { Sprite } from '@pixi/sprite';

import { Shared } from '../App';
import LocalisedText from './LocalisedText';
import { Widget } from './Widget';

export class GoWidget extends Widget
{
    private label!: LocalisedText;
    private arrow!: Sprite;
    private count = 0;
    private duration = 0;

    protected async build(): Promise<void>
    {
        this.label = new LocalisedText('game_go', {
            fill: 'white',
            align: 'right',
            fontSize: 80,
            fontFamily: 'lubalin',
            lineJoin: 'round',
            stroke: 0x333333,
            strokeThickness: 20,
        });
        this.label.anchor.set(1, 0.5);
        this.view.addChild(this.label);
        this.label.y = -2;

        this.arrow = new Sprite(Shared.assets.getTexture('icon-double-arrow'));
        this.arrow.anchor.set(0.5);
        this.arrow.scale.set(2);
        this.view.addChild(this.arrow);
        this.arrow.x = this.arrow.width / 2;
    }

    public async show(delay = 0, duration = 99): Promise<void>
    {
        await waitFor(delay * 1000);
        this.duration = duration;
        this.open();
    }

    protected async onOpen(): Promise<void>
    {
        this.view.alpha = 0;
        this.count = 0;
    }

    public update(d = 1): void
    {
        if (!this._opened) return;
        this.count += d;

        const alpha = Math.floor(this.count * 0.1) % 2 ? 0.1 : 1;

        if (alpha === 1 && alpha !== this.view.alpha) Shared.game.soundSystem.playSfx('btn-click', 0.5);
        this.view.alpha = alpha;

        this.duration -= (d / 60);
        if (this.duration <= 0)
        {
            this.duration = 0;
            this.close();
        }
    }
}
